import {
  GET_ORGANIZATIONS_REQUEST,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  status: statusType.IDLE,
  initialLoading: true
}

const organizations = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case GET_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_ORGANIZATIONS_SUCCESS:
      return {
        data: payload.data,
        total: payload.total,
        status: statusType.SUCCESS,
        initialLoading: false
      }

    case GET_ORGANIZATIONS_FAILURE:
      return {
        ...state,
        status: statusType.ERROR,
        initialLoading: false
      }

    default:
      return state
  }
}

export default organizations
